module.exports = __webpack_public_path__ + "static/media/quy-hoach-ninh-thuan.c8da3b0d.jpg";